<template>
    <div>
        <div id="content" class="content animated slideInRight delay-1s">
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-header">
                            <div class="card-title">
                                Cadastrar Departamento
                                <span class="required_fields"><span class="required">*</span> Campos obrigatórios</span>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-12">
                                    <form id="form">
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="description"><span class="required">*</span> Descrição:</label>
                                                    <input type="text" class='form-control' v-model="department.description">
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="description"><span class="required">*</span> Gestor:</label>
                                                    <v-select :options="users" label="name" :reduce="users => users.id" class="style-chooser" v-model="department.user_id">
                                                        <div slot="no-options">Carregando...</div>
                                                    </v-select>
                                                </div>
                                            </div>
										</div>
                                        <div class="row">
                                            <div class="col-md-6">
											<div class="add-type">Permitir Múltiplas Reservas?</div>
												<div class="custom-control custom-switch">
													<input type="checkbox" class="custom-control-input" id="multiple" v-model="department.multiple_reserves" />
													<label class="custom-control-label" for="multiple"></label>
                                                </div>
											<div class="clearfix"></div>
                                            </div>
                                            <div class="col-md-6" v-if="department.multiple_reserves == true">
                                                <div class="form-group">
                                                    <label for="description"><span class="required"></span> Quantidade Máxima de Reservas:</label>
                                                    <input type="text" class='form-control' v-model="department.quantity_reserves">
                                                </div>
                                            </div>
										</div>
                                        <hr>
                                        <div class="block text-right">
                                            <a class="btn btn-add" @click="save">
                                                Salvar <i class="fa fa-save"></i>
                                            </a>
                                            <router-link to="/departments" class="btn btn-back">
                                                <i class="fa fa-arrow-left"></i> Voltar
                                            </router-link>
                                        </div>
                                    </form>
                                </div>
                            </div>
						</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import vSelect from 'vue-select'

    export default {
        data() {
            return {
                department: {
                    description: '',
                    user_id: '',
                    multiple_reserves: 0,
                    quantity_reserves: 1
                },
                users: []
            }
        },
        methods: {
            makeFormData: function(){
                const self = this;
                let fd  = new FormData();

                fd.append('description', self.department.description);
                fd.append('user_id', self.department.user_id);
                fd.append('multiple_reserves', self.department.multiple_reserves);
                fd.append('quantity_reserves', self.department.quantity_reserves);

                if(self.department.id){
                    fd.append('id', self.department.id);
                    fd.append('_method', 'PUT');
                }

                return fd;
            },
            save: function () {
                const self = this;
                let api = self.$store.state.api + 'departments';

                let fd = self.makeFormData();

                if(self.department.id){
                    api += '/' + self.department.id;
                }

                self.$http.post(api, fd)
                    .then((response) => {
                        self.$message('Sucesso', `Informações guardadas com sucesso`, 'success');
                        this.$router.push('/departments');
                    })
                    .catch((error) => {
                        self.$message(null, error.response.data, 'error');
                    });
            },
            getDepartments: function (id) {
                const self = this;
                const api = self.$store.state.api + 'departments/' + id;

                self.$http.get(api)
                    .then((response) => {
                        self.department = response.data.data[0]
                    })
                    .catch((error) => {
                        self.$message(null, error.response.data, 'error');
                    });
            },
            getUsers: function (id) {
                const self = this;
                const api = self.$store.state.api + 'managers?paginated=false';

                self.$http.get(api)
                    .then((response) => {
                        self.users = response.data.data
                    })
                    .catch((error) => {
                        self.$message(null, error.response.data, 'error');
                    });
            },
        },
        mounted: function(){
            const self = this;
            let id = self.$route.params.id;
            self.getUsers();
            if(id){
                self.getDepartments(id);
            }
        },
        components: {
          vSelect
        },
    }
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Department/Add.vue